export default __webpack_public_path__ + "static/media/Shalini.b65feeac.jpg";